// logger.js
export const getConsole = (() => {
  const urlParams = new URLSearchParams(window.location.search)
  let showConsole = urlParams.get('showConsole') === 'true'

  if (window.app.config.CONFIG_KEY !== 'production') showConsole = true

  if (showConsole) {
    // Use the native console if showConsole is true.
    return console
  } else {
    // Always show errors and warnings, even if console is disabled.
    return {
      log: () => {},
      info: () => {},
      debug: () => {},
      warn: console.warn.bind(console),
      error: console.error.bind(console),
    }
  }
})()
